
import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Language } from "@/models/Language";
import publicApi from "@/network/public_api";
import { AxiosError, AxiosResponse } from "axios";
import { i18n } from "@/i18n";
import { Locales } from "../../i18n/locales";

import { $internalHooks } from "vue-class-component/lib/component";
import router from "../../router";

@Component
export default class ForgetPassword extends Vue {
  @Prop({
    type: Boolean,
    required: true,
  })
  readonly showForgetPassword!: boolean;
  @Getter("userLanguageId") private currentLanguage!: Language;

  forget_email = "";
  disableInput = false;
  @Emit("closeForgetPassword")
  close() {
    return false;
  }

  mounted() {
    window.onpopstate = () => {
      this.$router.go(0);
    };
  }

  resetPassword() {
    if (this.forget_email && this.forget_email.length > 5) {
      publicApi
        .post(
          "forget_password",
          { email: this.forget_email },
          {
            headers: {
              "X-Localization": i18n.locale,
            },
          }
        )
        .then((response: AxiosResponse) => {
          this.disableInput = true;
          (Vue as any).$toast.success(
            i18n.t("A password reset link will be sent to the registered email address").toString(),
            {
              position:
                this.$i18n.locale === Locales.EN ? "top-right" : "top-left",
            }
          );

          // Give half a second for the user to see success feedback then redirect to login.
          setTimeout(() => {
            this.$router.go(0);
          }, 500);
        })
        .catch((err: AxiosError) => {
          (Vue as any).$toast.error(err?.response?.data?.message, {
            position:
              this.$i18n.locale === Locales.EN ? "top-right" : "top-left",
          });
        });
    } else {
      (Vue as any).$toast.warning(i18n.t("Invalid Email Address").toString(), {
        position: this.$i18n.locale === Locales.EN ? "top-right" : "top-left",
      });
    }
  }
}
